/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeTransaction,
    RuntimeTransactionFromJSON,
    RuntimeTransactionFromJSONTyped,
    RuntimeTransactionToJSON,
} from './';

/**
 * A list of runtime transactions.
 * @export
 * @interface RuntimeTransactionListAllOf
 */
export interface RuntimeTransactionListAllOf {
    /**
     * 
     * @type {Array<RuntimeTransaction>}
     * @memberof RuntimeTransactionListAllOf
     */
    transactions: Array<RuntimeTransaction>;
}

export function RuntimeTransactionListAllOfFromJSON(json: any): RuntimeTransactionListAllOf {
    return RuntimeTransactionListAllOfFromJSONTyped(json, false);
}

export function RuntimeTransactionListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeTransactionListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(RuntimeTransactionFromJSON)),
    };
}

export function RuntimeTransactionListAllOfToJSON(value?: RuntimeTransactionListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': ((value.transactions as Array<any>).map(RuntimeTransactionToJSON)),
    };
}


